export default __webpack_public_path__ + "static/project-ball-600ef16e1a3627a92b737aa28fe5784e.png";